function indexToLetter(index, current = "") {
  if (index < 0)
    return current;
  const quotient = Math.floor(index / 26);
  const remainder = index % 26;
  current = String.fromCharCode(65 + remainder) + current;
  return indexToLetter(quotient - 1, current);
}
export {
  indexToLetter
};
//# sourceMappingURL=index220.js.map
